export default __webpack_public_path__ + "static/media/cogeco-blue.616e893f.png";